import React from 'react';

export const useVerticalScrollIntoView = (elementId: string) => {
  const elementRef = React.useRef<HTMLElement | null>(null);

  React.useEffect(() => {
    elementRef.current = document.getElementById(elementId);
  }, [elementId]);

  const scrollToElement = () => {
    if (elementRef.current) {
      elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return scrollToElement;
};

export default useVerticalScrollIntoView;
